import { Alert, Text } from 'braid-design-system';

import { useLocalDemo } from '#src/context/LocalDemoContext';

export const LocalDemoBanner = () => {
  const { isLocalDemo } = useLocalDemo();

  if (!isLocalDemo) {
    return null;
  }

  return (
    <Alert tone="caution">
      <Text>
        Local demo mode — this site is using sample data. Changes are not saved
        to production.
      </Text>
    </Alert>
  );
};
